import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import ConnectionMixin, { ConnectionMixinDefaultValues } from 'automation-ui-action-features/records/connection/ConnectionMixin';
import ConnectorMixin, { ConnectorMixinDefaultValues } from 'automation-ui-action-features/records/connection/ConnectorMixin';
/**
 * A `SingleConnection` reflects the BE representation of the connection object
 * found on any action with only one resulting edge. SingleConnection is unique
 * in that it is both a Connection and a Connector and therefore can be `null`
 * to represent a leaf edge.
 *
 * The SingleConnection class inherits both Connection and Connector behavior by
 * way of class mixins. Passing the Record class into Connector mixin here
 * creates a record named 'SingleConnection' that can behave as a Connector.
 * Passing that class into ConnectionMixin creates a class that can also behave
 * as a Connection.  The default values expected by Connection and Connector
 * must be passed in here as the mixins are defined without knowledge of the
 * Record.
 *
 * See the definition of `ConnectorMixin` for more details about class mixins.
 */
export default class SingleConnection extends ConnectionMixin(ConnectorMixin(createImmutableObjectClass(Object.assign({}, ConnectionMixinDefaultValues, ConnectorMixinDefaultValues)))) {
  getConnectors() {
    return [this];
  }
  updateConnectors(updater) {
    return updater(this);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getConnectorByEdgeId(edgeId) {
    return this;
  }
  setConnectorByEdgeId(edgeId, connector) {
    return connector === null ? null : new SingleConnection(Object.assign({}, this.toJSON(), connector));
  }
  sanitizeConnector({
    rootLoopNodeId // eslint-disable-line @typescript-eslint/no-unused-vars
  }) {
    return this;
  }
}